import { render, staticRenderFns } from "./TaskMRList.vue?vue&type=template&id=3654ebba"
import script from "./TaskMRList.vue?vue&type=script&lang=ts"
export * from "./TaskMRList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports